import { render } from "./SearchCompany.vue?vue&type=template&id=c5bd73a8&scoped=true&ts=true"
import script from "./SearchCompany.vue?vue&type=script&lang=ts"
export * from "./SearchCompany.vue?vue&type=script&lang=ts"

import "./SearchCompany.vue?vue&type=style&index=0&id=c5bd73a8&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5bd73a8"]])

export default __exports__